/* eslint-disable react/forbid-dom-props */ /* eslint-disable no-prototype-builtins */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Callout, DirectionalHint, PrimaryButton, mergeStyleSets } from '@fluentui/react';
import SpzaComponent from '@shared/components/spzaComponent';
import { getCountryRegionByCountry, getReplacedCountryQueryParam, createCountryFilterQueryParam, getStartingPriceHeader, getStartingPriceCurrency } from '@shared/utils/consultingServicesUtils';
import { isFilterItemMatch, getFilterItemRoute, getDetailsPageTitle } from '@appsource/utils/consultingServicesUtils';
import { InternalLink } from '@shared/components/internalLink';
import { Constants } from '@shared/utils/constants';
import { DataMap } from '@shared/utils/dataMapping';
import { urlPush, urlReplace, routes } from 'routerHistory';
import { getWindow } from '@shared/services/window';
import { ServiceTile } from '@shared/containers/serviceTile';
import Overview from '@appsource/containers/overview';
import * as DetailUtils from '@shared/utils/detailUtils';
import { serviceOffersSupportedCountries, findServiceSupportedCountry } from '@shared/utils/filterHelpers';
import { serviceOffersSupportedCAStates, serviceOffersSupportedUSStates } from '@shared/utils/serviceOffersSupportedStatesCodes';
import { getServiceTelemetryDetailContentText } from '@shared/utils/appUtils';
import { getUserFavouriteEntityServiceType } from '@shared/utils/userFavouriteDedicatedUtils';
import UserFavouriteTileDetailButton from '@shared/containers/userFavouriteTileDetailButton';
import { Card } from '@shared/components/card';
import { ButtonLink } from '@shared/components/ButtonLink';
import { Tab, Tabs } from '@shared/components/tabs';
import { UsefulInfo, UsefulInfoMetadataCellItemType } from './UsefulInfo';
import { getWorkBreakEnabledString } from 'utils/stringUtils';
import { StickyCard } from 'components/stickyCard';
import { IconLink } from 'components/iconLink';
import { getTooltipSilentLogIn } from '@shared/utils/silentLogInUtils';
import { logger } from '@src/logger';
import pdpSolutionBadge from '@shared/images/pdp_solutionBadge.svg';
import pdpMspBadge from '@shared/images/pdp_mspBadge.svg';
import classNames from 'classnames';
const MAX_REGIONS_IN_VIEW_COUNT = 5;
const MAX_COUNTRIES_IN_VIEW_COUNT = 5;
const ctaButtonsClassNames = mergeStyleSets({
    ctaButton: {
        padding: '5px 25px',
        marginTop: 4,
        marginRight: 8
    }
});
export class ServiceDetails extends SpzaComponent {
    static getRegionColumns(countryCode, regions) {
        const regionLists = [];
        if (!countryCode || !regions) {
            return regionLists;
        }
        const columnSize = 15;
        const maxColumns = 4;
        for(let i = 0; i < maxColumns; i++){
            regionLists.push(regions.slice(columnSize * i, columnSize * i + columnSize).map(function(listValue) {
                let region = {};
                if (countryCode.toLowerCase() === Constants.usCountryCode) {
                    region = serviceOffersSupportedUSStates.filter((item)=>{
                        return item.code === listValue;
                    });
                } else {
                    region = serviceOffersSupportedCAStates.filter((item)=>{
                        return item.code === listValue;
                    });
                }
                return region && region.length > 0 ? region[0].name : undefined;
            }));
        }
        return regionLists;
    }
    static getMoreCountriesColumns(moreCountries) {
        const countriesLists = [];
        if (!moreCountries) {
            return countriesLists;
        }
        const columnSize = 25;
        const maxColumns = 6;
        for(let i = 0; i < maxColumns; i++){
            countriesLists.push(moreCountries.slice(columnSize * i, columnSize * i + columnSize).map((moreCountryVal)=>{
                const foundCountry = serviceOffersSupportedCountries.filter((supportedCountry)=>{
                    return supportedCountry.countryCode === moreCountryVal.countryCode;
                });
                return foundCountry && foundCountry.length > 0 ? moreCountryVal : undefined;
            }));
        }
        return countriesLists;
    }
    handleScroll() {
        const curWindow = getWindow();
        const isPageScrolled = StickyCard.handleScroll(curWindow, ServiceDetails.pdpTabsId);
        if (this.state.isPageScrolled !== isPageScrolled) {
            this.setState({
                isPageScrolled
            });
        }
    }
    buildGalleryLink() {
        const { isConverged } = this.props;
        const buttonText = isConverged ? this.context.loc('Filter_ProfessionalServices', 'Professional services') : this.context.loc('Services_BackButton', 'Consulting services');
        return /*#__PURE__*/ _jsx(InternalLink, {
            href: this.props.breadcrumbUrl,
            role: "button",
            className: "c-button goBackButton",
            onClick: ()=>{
                DetailUtils.generateBreadcrumbPayloadAndLogTelemetry('Services');
                urlPush(this.props.breadcrumbUrl, true);
            },
            accEnabled: true,
            children: buttonText
        });
    }
    buildStateListItems(region) {
        return /*#__PURE__*/ _jsx("div", {
            className: "column",
            children: region.map(function(listValue) {
                return /*#__PURE__*/ _jsx("li", {
                    children: listValue
                }, listValue);
            })
        });
    }
    getServiceDetailsHref(countryCode) {
        const query = this.props.query;
        let countryParams = getReplacedCountryQueryParam(query, countryCode);
        if (!countryParams) {
            countryParams = createCountryFilterQueryParam(countryCode, this.props.isAppSource);
        }
        return this.context.buildHref(routes.serviceDetail, {
            entityId: this.props.service.entityId
        }, countryParams, true);
    }
    buildMoreCountriesListItems(moreCountries, colIndex) {
        const closeMoreCountriesModal = this.closeMoreCountriesModal;
        return /*#__PURE__*/ _jsx("div", {
            className: "column",
            children: moreCountries.map((moreCountry)=>{
                const serviceDetailHref = this.getServiceDetailsHref(moreCountry.countryCode);
                return /*#__PURE__*/ _jsx(InternalLink, {
                    href: serviceDetailHref,
                    scrollToTop: true,
                    className: "c-hyperlink",
                    additionalCommand: closeMoreCountriesModal,
                    children: moreCountry.countryDisplayName
                }, moreCountry.countryCode);
            })
        }, colIndex);
    }
    closeRegionModal(event) {
        event.stopPropagation();
        this.setState({
            showRegionModal: false
        });
    }
    buildRegionModal(regions) {
        const { service, countryCode } = this.props;
        const { countryRegion } = getCountryRegionByCountry({
            service,
            countryCode
        });
        const countryName = this.getCountryDisplayName(countryRegion);
        const regionColumns = ServiceDetails.getRegionColumns(countryRegion, regions);
        const regionLists = regionColumns.map((columnRegions)=>{
            return this.buildStateListItems(columnRegions);
        });
        return this.state.showRegionModal && /*#__PURE__*/ _jsxs(Callout, {
            onMouseLeave: this.closeRegionModal,
            target: ".regionLink",
            directionalHint: DirectionalHint.rightCenter,
            className: "regionCallout",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "regionsHeader",
                    children: this.context.locParams('ServicesRegions_Header', [
                        countryName
                    ])
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "regionColumns",
                    children: regionLists
                })
            ]
        });
    }
    buildRegionList() {
        const { service, countryCode } = this.props;
        const { marketStates, countryRegion } = getCountryRegionByCountry({
            service,
            countryCode
        });
        const regions = marketStates;
        let regionsAddedToView = 0;
        const regionList = [];
        if (regions && regions.length > 0) {
            for(let i = 0; i < regions.length; i++){
                let region = {};
                if (countryRegion.toLowerCase() === Constants.usCountryCode) {
                    region = serviceOffersSupportedUSStates.filter((item)=>{
                        return item.code === regions[`${i}`];
                    });
                } else if (countryRegion.toLowerCase() === Constants.caCountryCode) {
                    region = serviceOffersSupportedCAStates.filter((item)=>{
                        return item.code === regions[`${i}`];
                    });
                }
                if (region && region.length > 0) {
                    regionsAddedToView++;
                    if (regionsAddedToView <= MAX_REGIONS_IN_VIEW_COUNT) {
                        regionList.push(region[0].name);
                    }
                }
            }
        }
        return regionList;
    }
    getShowRegionModal(regions) {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.state.showRegionModal ? /*#__PURE__*/ _jsx("div", {
                    className: "overlay"
                }) : null,
                /*#__PURE__*/ _jsxs("div", {
                    className: "regionLink",
                    onClick: ()=>{
                        this.setState({
                            showRegionModal: true
                        });
                    },
                    onKeyDown: (event)=>{
                        if (event.keyCode === Constants.SystemKey.Enter) {
                            this.setState({
                                showRegionModal: true
                            });
                        }
                    },
                    tabIndex: 0,
                    children: [
                        this.context.locParams('CountryLink_More', [
                            regions.length.toString()
                        ]),
                        /*#__PURE__*/ _jsx("div", {
                            children: this.buildRegionModal(regions)
                        })
                    ]
                })
            ]
        });
    }
    getMoreCountriesCodeAndDisplay(countries) {
        const moreCountries = [];
        const countryCodeLowerCase = this.props.countryCode ? this.props.countryCode.toLowerCase() : null;
        for (const country of countries){
            if (country.countryRegion.toLowerCase() !== countryCodeLowerCase) {
                const foundCountry = findServiceSupportedCountry(country.countryRegion);
                if (foundCountry) {
                    moreCountries.push({
                        countryCode: country.countryRegion,
                        countryDisplayName: foundCountry.name
                    });
                } else {
                    const errorMessage = `Country code not found in service supported countries, code =  ${country.countryRegion}.`;
                    const payload = {
                        page: getWindow().location.href,
                        action: Constants.Telemetry.Action.Error,
                        actionModifier: Constants.Telemetry.ActionModifier.Error,
                        details: JSON.stringify(errorMessage)
                    };
                    logger.error(payload.details, {
                        action: payload.action,
                        actionModifier: payload.actionModifier
                    });
                }
            }
        }
        return moreCountries;
    }
    closeMoreCountriesModal(event) {
        if (event) {
            event.stopPropagation();
        }
        this.setState({
            showMoreCountriesModal: false
        });
    }
    buildMoreCountriesModal(moreCountries) {
        const moreCountriesColumns = ServiceDetails.getMoreCountriesColumns(moreCountries);
        const moreCountriesLists = moreCountriesColumns.map((columnMoreCountries, colIndex)=>{
            return this.buildMoreCountriesListItems(columnMoreCountries, colIndex);
        });
        return this.state.showMoreCountriesModal && /*#__PURE__*/ _jsxs(Callout, {
            onMouseLeave: this.closeMoreCountriesModal,
            target: ".moreCountriesLink",
            directionalHint: DirectionalHint.rightCenter,
            className: "regionCallout",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "regionsHeader",
                    children: this.context.loc('ServiceDetails_MoreCountries')
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "regionColumns",
                    children: moreCountriesLists
                })
            ]
        });
    }
    buildMoreCountriesList(countries) {
        const countryLists = {
            topCountries: [],
            countriesMoreModalList: []
        };
        const moreCountries = this.getMoreCountriesCodeAndDisplay(countries);
        // If any they will be shown in popup
        for(let i = 0; i < moreCountries.length; i++){
            if (i < MAX_COUNTRIES_IN_VIEW_COUNT) {
                // Set url with the right country for each link to details page.
                const serviceDetailHref = this.getServiceDetailsHref(moreCountries[`${i}`].countryCode);
                countryLists.topCountries.push({
                    information: serviceDetailHref,
                    id: moreCountries[`${i}`].countryCode,
                    text: moreCountries[`${i}`].countryDisplayName,
                    type: UsefulInfoMetadataCellItemType.InternalLink,
                    props: {
                        scrollToTop: true,
                        additionalCommand: this.closeMoreCountriesModal,
                        target: '_self'
                    }
                });
            } else {
                countryLists.countriesMoreModalList.push(moreCountries[`${i}`]);
            }
        }
        return countryLists;
    }
    getMoreCountriesModal(extraMoreCountries) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "moreCountriesLink",
            onClick: ()=>{
                this.setState({
                    showMoreCountriesModal: true
                });
            },
            onKeyDown: (event)=>{
                if (event.keyCode === Constants.SystemKey.Enter) {
                    this.setState({
                        showMoreCountriesModal: true
                    });
                }
            },
            tabIndex: 0,
            children: [
                this.context.locParams('CountryLink_More', [
                    extraMoreCountries.length.toString()
                ]),
                /*#__PURE__*/ _jsx("div", {
                    children: this.buildMoreCountriesModal(extraMoreCountries)
                }, "show_more_model")
            ]
        }, "show_more");
    }
    buildCompetencyList(items) {
        const itemRender = [];
        if (items && items.length > 0) {
            for(let i = 0; i < items.length; i++){
                itemRender.push(/*#__PURE__*/ _jsx("div", {
                    className: "displayItem",
                    children: items[`${i}`].competencyName
                }, i));
            }
        }
        return itemRender;
    }
    buildFilterElements(filteritems) {
        const azureIcons = [
            'analytics',
            'app-modernization',
            'archive',
            'ai-plus-machine-learning',
            'backup',
            'big-data',
            'data-platform',
            'datacenter-management',
            'devops',
            'disaster-recovery',
            'identity',
            'internet-of-things',
            'migration',
            'networking',
            'security',
            'storage'
        ];
        if (filteritems) {
            let filterElements = filteritems.map((filter)=>{
                const iconType = azureIcons.includes(filter.urlKey) ? 'azure' : filter.urlKey;
                return /*#__PURE__*/ _jsx(IconLink, {
                    iconClassName: 'icon-' + iconType + '-16',
                    href: filter.newPath,
                    title: this.context.loc(filter.locKey, filter.title),
                    onClick: (e)=>{
                        DetailUtils.generateLinkPayloadAndLogTelemetry(DetailUtils.OwnerType.Service, this.props.service.entityId, filter.filterItem, filter.newPath, 'Default');
                        urlPush(filter.newPath, true);
                        e.preventDefault();
                    },
                    accEnabled: true,
                    className: "c-hyperlink detailsCategories",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "productItem",
                        children: this.context.loc(filter.locKey, filter.title)
                    })
                }, filter.title);
            });
            filterElements = filterElements.filter((element)=>!!element);
            return filterElements;
        }
        return null;
    }
    getFilterListElements(filterItem, filterTileType) {
        const filteritems = [];
        if (this.props.service) {
            Object.keys(DataMap[`${filterItem}`]).forEach((filterValue)=>{
                // Ugly but necessary. We need to show office365 product (office in data map file) even if it have ShortcutFilters.
                const filterValueAllowed = !DataMap[`${filterItem}`][`${filterValue}`].ShortcutFilters || filterTileType === Constants.filterTileTypes.product && filterValue === 'office';
                if (filterValueAllowed && (DataMap[`${filterItem}`][`${filterValue}`].match ? DataMap[`${filterItem}`][`${filterValue}`].match(this.props.service) : isFilterItemMatch({
                    service: this.props.service,
                    filterItem,
                    filterValue
                }))) {
                    const filter = DataMap[`${filterItem}`][`${filterValue}`];
                    if (!filter) {
                        return null;
                    }
                    // !!! Temporary HACK: If longTitle is 'Power BI apps' and we are in consulting services tab,
                    // then we make the text 'Power BI'.
                    const longTitle = filter.LongTitle || filter.title;
                    if (longTitle === 'Power BI apps') {
                        filter.LocKey = 'Power_BI';
                        filter.LongTitle = 'Power BI';
                    }
                    const routeParams = getFilterItemRoute({
                        filterItem,
                        filterValue,
                        filterTileType
                    });
                    const newPath = this.context.buildHref(routes.marketplaceServices, routeParams.routeArgs, routeParams.params);
                    filteritems.push({
                        filterItem,
                        locKey: filter.LocKey,
                        newPath,
                        title: filter.LongTitle,
                        urlKey: filter.UrlKey
                    });
                }
            });
        }
        return filteritems;
    }
    showDialog() {
        this.context.ctaCallback({
            entity: this.props.service,
            entityType: Constants.EntityType.Service,
            ctaType: Constants.CTAType.Service,
            actionModifier: Constants.Telemetry.ActionModifier.ServiceDetailCTAButton,
            ribbonKey: this.props.ribbonKey
        });
    }
    getRegionList() {
        const countryLists = {
            topCountries: [],
            countriesMoreModalList: []
        };
        const { service, countryCode } = this.props;
        const { marketStates, countryRegion } = getCountryRegionByCountry({
            service,
            countryCode
        });
        const regions = marketStates;
        let regionsAddedToView = 0;
        if (regions && regions.length > 0) {
            for(let i = 0; i < regions.length; i++){
                let region = {};
                if (countryRegion.toLowerCase() === Constants.usCountryCode) {
                    region = serviceOffersSupportedUSStates.filter((item)=>{
                        return item.code === regions[`${i}`];
                    });
                } else if (countryRegion.toLowerCase() === Constants.caCountryCode) {
                    region = serviceOffersSupportedCAStates.filter((item)=>{
                        return item.code === regions[`${i}`];
                    });
                }
                if (region && region.length > 0) {
                    regionsAddedToView++;
                    if (regionsAddedToView <= MAX_REGIONS_IN_VIEW_COUNT) {
                        countryLists.topCountries.push({
                            id: region[0].name,
                            type: UsefulInfoMetadataCellItemType.Label,
                            text: region[0].name
                        });
                    } else {
                        countryLists.countriesMoreModalList.push(region[0].code);
                    }
                }
            }
        }
        return countryLists;
    }
    ensureAsyncData(nextProps) {
        if (nextProps.serviceId) {
            this.props.ensureAsyncData(nextProps.serviceId);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.ensureAsyncData(nextProps);
    }
    componentDidMount() {
        var // Scroll to the top of the page when component mounts
        _getWindow;
        this.ensureAsyncData(this.props);
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.scrollTo(0, 0);
        if (this.props.service) {
            this.telemetryPageLoad();
            this.updateWindowTitle();
            this.addScrollListener();
        }
    }
    componentDidUpdate() {
        this.handleScroll();
    }
    componentWillUnmount() {
        this.removeScrollListener();
    }
    telemetryPageLoad() {
        const { service: serviceInfo, currentView, isNationalCloud } = this.props;
        const { title, entityId: serviceId } = serviceInfo || {};
        const payload = {
            page: getWindow().location.href,
            appName: title,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End,
            serviceId,
            details: getServiceTelemetryDetailContentText({
                serviceInfo,
                isNationalCloud,
                ctaTypes: [
                    Constants.CTAType.Service
                ],
                currentView
            })
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
    }
    updateWindowTitle() {
        var _document_getElementsByTagName;
        const { isConverged } = this.props;
        if ((_document_getElementsByTagName = document.getElementsByTagName('title')) === null || _document_getElementsByTagName === void 0 ? void 0 : _document_getElementsByTagName.length) {
            document.getElementsByTagName('title')[0].innerHTML = getDetailsPageTitle({
                context: this.context,
                isConverged,
                title: this.props.service.title
            });
        }
    }
    addScrollListener() {
        if (this.curWindow) {
            this.curWindow.addEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    removeScrollListener() {
        if (this.curWindow) {
            this.curWindow.addEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    getBreadcrumbElement() {
        return(// eslint-disable-next-line react/forbid-dom-props
        /*#__PURE__*/ _jsx("div", {
            className: "navigationBar",
            id: "maincontent",
            children: /*#__PURE__*/ _jsxs("nav", {
                className: "breadcrumb",
                children: [
                    this.buildGalleryLink(),
                    /*#__PURE__*/ _jsx("span", {
                        className: "c-glyph",
                        tabIndex: 0,
                        "aria-label": "greater than",
                        role: "contentinfo"
                    }),
                    /*#__PURE__*/ _jsx("header", {
                        className: "appTabButton",
                        children: this.props.service.title
                    })
                ]
            })
        }));
    }
    renderButtonLink({ label, value, pricingLinkClassName }) {
        return /*#__PURE__*/ _jsx(ButtonLink, {
            href: '',
            className: pricingLinkClassName,
            type: Constants.ButtonType.Label,
            accEnabled: true,
            label: label,
            value: value
        });
    }
    bulidStartingPriceElement({ pricingLinkClassName }) {
        var _service_extraData, _this_props_service_extraData, _this_props_service;
        const { service, countryCode, selectedLocale, isProfessionalService } = this.props;
        const pricingValue = getStartingPriceHeader(service === null || service === void 0 ? void 0 : (_service_extraData = service.extraData) === null || _service_extraData === void 0 ? void 0 : _service_extraData.multiCountryPricing, countryCode, selectedLocale, this.context);
        return /*#__PURE__*/ _jsxs("div", {
            className: "serviceDetailsPricingSection",
            itemProp: "offers",
            itemScope: true,
            itemType: "https://schema.org/Offer",
            children: [
                isProfessionalService ? this.renderButtonLink({
                    label: this.context.loc('ProfessionalService_Price', 'Contact for price'),
                    value: '',
                    pricingLinkClassName
                }) : this.renderButtonLink({
                    label: this.context.loc('Pricing', 'Pricing'),
                    value: pricingValue,
                    pricingLinkClassName
                }),
                pricingValue === this.context.loc('Pricing_Free') ? /*#__PURE__*/ _jsxs("div", {
                    className: "metaTagForPrice",
                    children: [
                        /*#__PURE__*/ _jsx("meta", {
                            itemProp: "price",
                            content: "0"
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            itemProp: "priceCurrency",
                            content: "USD"
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            itemProp: "category",
                            content: "free"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "metaTagForPrice",
                    children: [
                        /*#__PURE__*/ _jsx("meta", {
                            itemProp: "price",
                            content: pricingValue.replace(/[^0-9.]/g, '')
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            itemProp: "priceCurrency",
                            content: getStartingPriceCurrency((_this_props_service = this.props.service) === null || _this_props_service === void 0 ? void 0 : (_this_props_service_extraData = _this_props_service.extraData) === null || _this_props_service_extraData === void 0 ? void 0 : _this_props_service_extraData.multiCountryPricing, this.props.countryCode)
                        })
                    ]
                })
            ]
        });
    }
    getCTAElement() {
        const { isLoadingUserData, service } = this.props;
        const button = /*#__PURE__*/ _jsx(PrimaryButton, {
            text: this.context.loc('PartnerDetail_ContactPartner', 'CONTACT PARTNER'),
            disabled: isLoadingUserData,
            "data-bi-id": Constants.JsllCTAId.ContactPartner,
            "data-bi-name": service.entityId,
            "data-bi-area": "Service Details",
            className: classNames([
                ctaButtonsClassNames.ctaButton,
                'requestButton'
            ]),
            onClick: this.showDialog.bind(this)
        });
        return getTooltipSilentLogIn(button, isLoadingUserData);
    }
    getUserFavouriteButton() {
        const service = this.props.service;
        if (!service) {
            return null;
        }
        return /*#__PURE__*/ _jsx(UserFavouriteTileDetailButton, {
            entityId: service.entityId,
            entityType: getUserFavouriteEntityServiceType(),
            planId: undefined,
            item: service,
            customCSS: ' AMPappDetails appSource-spza-user-favourite-tile-detail-button'
        });
    }
    getBadges() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "badgesBlock",
            children: [
                Constants.ServicesIdWithBadge.hasOwnProperty(this.props.service.entityId) ? /*#__PURE__*/ _jsx("a", {
                    href: "https://aka.ms/integratedsolutionslearnmore",
                    rel: "noreferrer",
                    target: "_blank",
                    children: /*#__PURE__*/ _jsx("img", {
                        id: "pdp_solution_badge",
                        className: "banner",
                        src: pdpSolutionBadge
                    })
                }) : null,
                this.props.service.tags && this.props.service.tags.indexOf(Constants.BadgeType.AzureExpertsMSP) >= 0 ? /*#__PURE__*/ _jsx("a", {
                    href: "https://aka.ms/AzureExpertMSP",
                    rel: "noreferrer",
                    target: "_blank",
                    children: /*#__PURE__*/ _jsx("img", {
                        id: "pdp_msp_badge",
                        className: "banner",
                        src: pdpMspBadge
                    })
                }) : null
            ]
        });
    }
    getChildContext() {
        return {
            openTileCallback: (detailUrl)=>{
                const detailsPaylod = {
                    linkType: 'App',
                    link: detailUrl
                };
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Click,
                    actionModifier: Constants.Telemetry.ActionModifier.Tile,
                    details: JSON.stringify(detailsPaylod)
                };
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                this.context.openTileCallback(detailUrl);
            }
        };
    }
    getDetailCellElement(information, headerContent, itemPropName) {
        const microTaggingItemPropName = itemPropName || '';
        if (information) {
            if (microTaggingItemPropName === 'publisher') {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "cell",
                    itemProp: microTaggingItemPropName,
                    itemScope: true,
                    itemType: "https://schema.org/Organization",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: headerContent
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            itemProp: "name",
                            children: information
                        })
                    ]
                });
            } else {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "cell",
                    itemProp: microTaggingItemPropName,
                    children: [
                        /*#__PURE__*/ _jsx("header", {
                            children: headerContent
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: information
                        })
                    ]
                });
            }
        } else {
            return null;
        }
    }
    getCountryDisplayName(countryCode) {
        const country = findServiceSupportedCountry(countryCode);
        if (country) {
            return country.name;
        }
        return '';
    }
    getCompetencyList(competencyType) {
        return this.props.service.detailInformation.competencies.filter((item)=>item.competencyLevel && item.competencyLevel.toString().toLowerCase() === competencyType);
    }
    getTabsProps() {
        const tabsProps = {
            defaultTab: this.props.defaultTab,
            ownerType: DetailUtils.OwnerType.Service,
            ownerId: this.props.service.entityId,
            changeTabCallback: this.changeTabCallback.bind(this),
            getTabHref: this.getTabHref.bind(this)
        };
        return tabsProps;
    }
    changeTabCallback(tabTitle) {
        const newPath = this.getTabHref(tabTitle);
        urlReplace(newPath);
    }
    getTabHref(tabTitle) {
        return this.context.buildHref(routes.serviceDetail, {
            entityId: this.props.service.entityId
        }, {
            tab: tabTitle
        }, true, false, true);
    }
    getTabChildren() {
        const tabsChilds = [
            {
                title: this.context.loc('PartnerDetail_OverviewTab', 'Overview'),
                name: 'Overview',
                getContent: ()=>this.renderOverviewTab()
            },
            {
                title: this.context.loc('ServiceDetail_DetilsAndSupportTab', 'Details + support'),
                name: Constants.Tabs.DetailsAndSupport,
                // eslint-disable-next-line react/display-name
                getContent: ()=>/*#__PURE__*/ _jsx(UsefulInfo, {
                        ownerType: DetailUtils.OwnerType.Service,
                        metadata: this.getUsefulInfoMetadata()
                    })
            }
        ];
        return tabsChilds;
    }
    getUsefulInfoMetadata() {
        var _this_props_service_extraData, _this_props_service_extraData1, _this_props_service, _this_props_service_industriesDetails, _contextCountryAndRegion_marketStates;
        const { isProfessionalService, service, countryCode, selectedLocale } = this.props;
        // colomn 1 - Useful Information
        const usefulInformaionCells = [];
        const supportCells = [];
        const moreLinksCells = [];
        const metadata = [];
        const contextCountryAndRegion = getCountryRegionByCountry({
            service,
            countryCode
        });
        const allCountryAndRegions = (_this_props_service_extraData = this.props.service.extraData) === null || _this_props_service_extraData === void 0 ? void 0 : _this_props_service_extraData.multiCountryPricing;
        // publisher
        usefulInformaionCells.push({
            id: 'publisher',
            title: 'App_Publisher',
            cellItems: [
                {
                    id: 'publisherItem',
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: service.publisher
                }
            ]
        });
        // pricing
        const pricingValue = getStartingPriceHeader((_this_props_service = this.props.service) === null || _this_props_service === void 0 ? void 0 : (_this_props_service_extraData1 = _this_props_service.extraData) === null || _this_props_service_extraData1 === void 0 ? void 0 : _this_props_service_extraData1.multiCountryPricing, countryCode, selectedLocale, this.context);
        if (pricingValue) {
            const cell = {
                id: 'AppVersionItem',
                type: UsefulInfoMetadataCellItemType.Label,
                text: isProfessionalService ? this.context.loc('ProfessionalService_Price', 'contact for price') : pricingValue
            };
            usefulInformaionCells.push({
                id: 'Pricing',
                title: 'Pricing',
                cellItems: [
                    cell
                ]
            });
        }
        // goldCompetencies
        if (this.props.service.detailInformation && this.props.service.detailInformation.competencies && this.props.service.detailInformation.competencies.length > 0 && this.getCompetencyList('gold').length > 0) {
            const goldCompetencies = this.props.service.detailInformation.competencies.filter((item)=>item.competencyLevel && item.competencyLevel.toString().toLowerCase() === 'gold').map((goldCompetency)=>{
                return {
                    id: goldCompetency.competencyName,
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: goldCompetency.competencyName
                };
            });
            if (goldCompetencies.length) {
                usefulInformaionCells.push({
                    id: 'GoldCompetencies',
                    title: 'ServiceDetails_GoldCompetencies',
                    cellItems: goldCompetencies
                });
            }
        }
        // silverCompetencies
        if (this.props.service.detailInformation && this.props.service.detailInformation.competencies && this.props.service.detailInformation.competencies.length > 0 && this.getCompetencyList('silver').length > 0) {
            const silverCompetencies = this.props.service.detailInformation.competencies.filter((item)=>item.competencyLevel && item.competencyLevel.toString().toLowerCase() === 'silver').map((silverCompetency)=>{
                return {
                    id: silverCompetency.competencyName,
                    type: UsefulInfoMetadataCellItemType.Label,
                    text: silverCompetency.competencyName
                };
            });
            if (silverCompetencies.length) {
                usefulInformaionCells.push({
                    id: 'SilverCompetencies',
                    title: 'ServiceDetails_SilverCompetencies',
                    cellItems: silverCompetencies
                });
            }
        }
        if (this.props.service.products && Object.keys(this.props.service.products).length > 0) {
            // products
            const products = this.getFilterListElements(Constants.filterMaps.products, Constants.filterTileTypes.product).map((product)=>{
                return {
                    id: product.title,
                    type: UsefulInfoMetadataCellItemType.Filter,
                    text: product.locKey,
                    entityId: service.entityId,
                    filter: product
                };
            });
            usefulInformaionCells.push({
                id: 'FilterType_Products',
                title: 'FilterType_Products',
                cellItems: products
            });
        }
        if ((_this_props_service_industriesDetails = this.props.service.industriesDetails) === null || _this_props_service_industriesDetails === void 0 ? void 0 : _this_props_service_industriesDetails.length) {
            // industries
            const industries = this.getIndustriesFilterListElements();
            usefulInformaionCells.push({
                id: 'Industries',
                title: 'App_Industries',
                cellItems: industries
            });
        }
        if (this.props.service.serviceTypes > 0) {
            // type
            const serviceTypes = this.getFilterListElements(Constants.filterMaps.serviceTypes, Constants.filterTileTypes.serviceType).map((serviceType)=>{
                return {
                    id: serviceType.title,
                    type: UsefulInfoMetadataCellItemType.Filter,
                    text: serviceType.locKey,
                    entityId: service.entityId,
                    filter: serviceType
                };
            });
            usefulInformaionCells.push({
                id: 'serviceTypes',
                title: 'FilterType_ServiceType',
                cellItems: serviceTypes
            });
        }
        // country
        if (contextCountryAndRegion && contextCountryAndRegion.countryRegion) {
            usefulInformaionCells.push({
                id: 'Country',
                title: 'ServiceDetails_Country',
                cellItems: [
                    {
                        id: 'countryRegionItem',
                        type: UsefulInfoMetadataCellItemType.Label,
                        text: this.getCountryDisplayName(contextCountryAndRegion.countryRegion)
                    }
                ]
            });
        }
        // Region
        if ((contextCountryAndRegion === null || contextCountryAndRegion === void 0 ? void 0 : (_contextCountryAndRegion_marketStates = contextCountryAndRegion.marketStates) === null || _contextCountryAndRegion_marketStates === void 0 ? void 0 : _contextCountryAndRegion_marketStates.length) > 0) {
            const countryLists = this.getRegionList();
            if (countryLists.topCountries.length > 0) {
                if (countryLists.countriesMoreModalList && countryLists.countriesMoreModalList.length > 0) countryLists.topCountries.push({
                    id: 'more',
                    text: 'CountryLink_More',
                    type: UsefulInfoMetadataCellItemType.Modal,
                    getContent: ()=>this.getShowRegionModal(countryLists.countriesMoreModalList)
                });
                usefulInformaionCells.push({
                    id: 'Region',
                    title: 'ServiceDetails_Regions',
                    cellItems: countryLists.topCountries
                });
            }
        }
        // MoreCountries
        if (allCountryAndRegions && allCountryAndRegions.length > 1) {
            const countryLists = this.buildMoreCountriesList(allCountryAndRegions);
            if (countryLists.topCountries.length > 0) {
                if (countryLists.countriesMoreModalList && countryLists.countriesMoreModalList.length > 0) {
                    countryLists.topCountries.push({
                        id: 'more',
                        text: 'CountryLink_More',
                        type: UsefulInfoMetadataCellItemType.Modal,
                        getContent: ()=>this.getMoreCountriesModal(countryLists.countriesMoreModalList)
                    });
                }
                usefulInformaionCells.push({
                    id: 'MoreCountries',
                    title: 'ServiceDetails_MoreCountries',
                    cellItems: countryLists.topCountries
                });
            }
        }
        // more links
        const documents = this.props.service.detailInformation.CollateralDocuments;
        if (documents && documents.length > 0) {
            const documentsCells = documents.map((doc)=>{
                return {
                    information: doc.DocumentUri,
                    id: 'LearnMore',
                    text: getWorkBreakEnabledString(doc.DocumentName),
                    type: UsefulInfoMetadataCellItemType.Link,
                    entityId: service.entityId
                };
            });
            moreLinksCells.push({
                id: 'App_LearnMoreTitle',
                title: '',
                cellItems: documentsCells
            });
        }
        // create root metadata item
        if (usefulInformaionCells.length) {
            metadata.push({
                id: 'UsefulInformationDetails',
                title: 'AppDetail_UsefulInformaionDetails',
                titleFallback: 'Details',
                cells: usefulInformaionCells
            });
        }
        if (supportCells.length) {
            metadata.push({
                id: 'Support',
                title: 'AppDetail_Support',
                cells: supportCells
            });
        }
        if (moreLinksCells.length) {
            metadata.push({
                id: 'App_Links',
                title: 'App_Links',
                titleFallback: 'Links',
                cells: moreLinksCells
            });
        }
        return metadata;
    }
    renderOverviewTab() {
        return this.props.service.detailInformation ? /*#__PURE__*/ _jsx(Overview, {
            ownerType: DetailUtils.OwnerType.App,
            ownerId: this.props.service.entityId,
            ownerTitle: this.props.service.title,
            shortDescription: this.props.service.extraData.shortDescription,
            description: this.props.service.detailInformation.Description,
            images: this.props.service.detailInformation.Images,
            videos: this.props.service.detailInformation.DemoVideos,
            capabilities: null,
            TileType: ServiceTile,
            crossListings: this.props.suggestedItems,
            //   selectedLocale={this.props.selectedLocale}
            countryCode: this.props.countryCode
        }) : null;
    }
    renderStickyCard(tabsProps, tabsChilds) {
        return /*#__PURE__*/ _jsxs(StickyCard, {
            title: this.props.service.title,
            logoURL: DetailUtils.getDetailInformation(this.props.service, 'LargeIconUri'),
            tabsProps: tabsProps,
            tabsChilds: tabsChilds,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "stickyCardPricing",
                    children: this.bulidStartingPriceElement({
                        pricingLinkClassName: 'light'
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "stickyCardButton",
                    children: this.getCTAElement()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "stickyCardFavourite",
                    children: this.getUserFavouriteButton()
                })
            ]
        });
    }
    renderImpl() {
        if (this.props.service) {
            const tabsProps = this.getTabsProps();
            const tabsChilds = this.getTabChildren();
            return /*#__PURE__*/ _jsx("div", {
                className: "ASdesktopAppDetails",
                tabIndex: 0,
                itemScope: true,
                itemType: "https://schema.org/SoftwareApplication",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "spza_detailContainer spza_partnerDetailContainer",
                    children: [
                        this.state.isPageScrolled ? this.renderStickyCard(tabsProps, tabsChilds) : null,
                        /*#__PURE__*/ _jsxs("div", {
                            className: "pdpDetails",
                            children: [
                                this.getBreadcrumbElement(),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "detailContent",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "deatilPageContent",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Card, {
                                                title: this.props.service.title,
                                                subtitle: this.props.service.publisher,
                                                logoURL: DetailUtils.getDetailInformation(this.props.service, 'LargeIconUri'),
                                                children: [
                                                    this.props.isHydrated && this.props.service.products && Object.keys(this.props.service.products).length > 0 ? this.buildFilterElements(this.getFilterListElements(Constants.filterMaps.products, Constants.filterTileTypes.product)) : null,
                                                    this.props.isHydrated && this.getBadges(),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "container",
                                                        children: [
                                                            this.bulidStartingPriceElement({
                                                                pricingLinkClassName: 'dark'
                                                            }),
                                                            this.getCTAElement(),
                                                            this.getUserFavouriteButton()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !this.props.service.detailInformation ? null : /*#__PURE__*/ _jsx("div", {
                                                id: ServiceDetails.pdpTabsId,
                                                className: ServiceDetails.pdpTabsClass,
                                                children: /*#__PURE__*/ _jsx(Tabs, {
                                                    defaultTab: tabsProps.defaultTab,
                                                    ownerType: tabsProps.ownerType,
                                                    ownerId: tabsProps.ownerId,
                                                    changeTabCallback: tabsProps.changeTabCallback,
                                                    getTabHref: tabsProps.getTabHref,
                                                    children: tabsChilds.map((tabChild, index)=>/*#__PURE__*/ _jsx(Tab, {
                                                            title: tabChild.title,
                                                            name: tabChild.name,
                                                            textBadge: tabChild.textBadge,
                                                            children: tabChild.getContent()
                                                        }, index))
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            // there is no app
            return /*#__PURE__*/ _jsx("div", {
                className: "nullAppContainer",
                children: this.context.loc('APPDETAIL_AppNotFound', 'App not Found')
            });
        }
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "curWindow", getWindow()), _define_property(this, "getIndustriesFilterListElements", ()=>{
            var _service_industriesDetails;
            const { service } = this.props;
            return service === null || service === void 0 ? void 0 : (_service_industriesDetails = service.industriesDetails) === null || _service_industriesDetails === void 0 ? void 0 : _service_industriesDetails.map((industryDetail)=>{
                const { urlKey, longTitle, locKey } = industryDetail;
                const newPath = this.context.buildHref(routes.marketplaceServices, null, {
                    industry: urlKey
                });
                const filter = {
                    filterItem: Constants.filterMaps.industries,
                    locKey,
                    newPath,
                    title: longTitle,
                    urlKey
                };
                return {
                    id: filter.title,
                    type: UsefulInfoMetadataCellItemType.Filter,
                    text: filter.locKey,
                    entityId: service.entityId,
                    filter
                };
            });
        });
        this.state = {
            showRegionModal: false,
            showMoreCountriesModal: false,
            isPageScrolled: false
        };
        this.closeRegionModal = this.closeRegionModal.bind(this);
        this.closeMoreCountriesModal = this.closeMoreCountriesModal.bind(this);
        this.getServiceDetailsHref = this.getServiceDetailsHref.bind(this);
    }
}
_define_property(ServiceDetails, "pdpTabsId", 'pdpTabs');
_define_property(ServiceDetails, "pdpTabsClass", 'pdpTabs');
ServiceDetails.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func,
    renderErrorModal: PropTypes.func,
    openTileCallback: PropTypes.func
};
ServiceDetails.childContextTypes = {
    openTileCallback: PropTypes.func
};
